import React from 'react';

import { Skeleton } from '@mui/material';

/** 포트폴리오 상세 > 투자유치이력 > 상단 써머리 스켈레톤 */
const PortfolioInvestSummarySkeleton = () => {
  return (
    <>
      <Skeleton
        variant="rectangular"
        height={110}
        sx={{
          borderRadius: '10px',
          boxShadow: '0px 0px 20px 0px rgba(206, 208, 214, 0.5)',
          marginBottom: '40px',
        }}
      />
    </>
  );
};

export default PortfolioInvestSummarySkeleton;
